import moment from "moment"
import { useAdminRoles } from "~/composables/permissions/adminRoles"

export default defineNuxtRouteMiddleware(async (to, from) => {

  const { isAdminRole, isOfficerRole, isCoordinatorRole, isObserverRole } = await useAdminRoles()
  const { loggedIn, session, fetch: fetchSession } = useUserSession()

  if (!to.path.startsWith("/public")) {
    await fetchSession()
  }

  if (
    !to.path.startsWith("/public") &&
    !loggedIn &&
    to.path !== "/" &&
    to.path !== "/auth/forgotten" &&
    to.path !== "/auth/login" &&
    to.path !== "/admin/login"
  ) {
    console.log("User not logged in")
    return navigateTo("/auth/login")
  }


  
  // check for user token expiration
  const loggedInAt = moment(session?.value?.loggedInAt)
  const tokenExpires = moment(loggedInAt).add(168, "hours")

  if (moment().isAfter(tokenExpires)) {
    console.warn("User token expired.")
    await clearSession() // log the user out
    if (isAdminRole) {
      return navigateTo("/admin/login")
    }
    return navigateTo("/auth/login")
  }

  // console.log("User logged in? ")
  // console.log(loggedIn.value)

  // redirect to admin dashboard if user is admin and tries to access a non-admin page
  if (loggedIn.value && isAdminRole && !to.path.startsWith("/admin")) {
    return navigateTo("/admin")
  }

  // redirect to user dashboard if user is logged in and tries to access admin page
  if (loggedIn.value && !isAdminRole && to.path.startsWith("/admin")) {
    return navigateTo("/projects")
  }

  return
})
